import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgClass } from '@angular/common';

export type SeSpriteAnimation = 'spin' | 'pulse';

export type SeSpriteFlipType = 'horizontal' | 'vertical' | 'both';

export type SeSpriteRotateType = '90' | '180' | '270';

export type SeSpriteSet = 'regular' | 'solid';

const SPRITE_MAPPINGS = {
    close: 'times',
};

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'se-sprite',
    styleUrls: ['./se-sprite.component.less'],
    templateUrl: './se-sprite.component.html',
    imports: [NgClass],
    standalone: true,
})
export class SeSpriteComponent implements OnChanges {
    classes: { [key: string]: boolean };

    spriteName: string;

    @Input()
    animation?: SeSpriteAnimation;

    @Input()
    flip?: SeSpriteFlipType;

    @Input()
    name: string;

    @Input()
    rotate?: SeSpriteRotateType;

    @Input()
    set = 'solid';

    ngOnChanges(changes: SimpleChanges) {
        this.calculateStyles();
    }

    private calculateStyles() {
        this.spriteName = SPRITE_MAPPINGS[this.name] || this.name;

        this.classes = {
            far: this.set === 'regular',
            fas: this.set === 'solid',

            'fa-pulse': this.animation === 'pulse',
            'fa-spin': this.animation === 'spin',

            'fa-flip-horizontal': this.flip === 'horizontal' || this.flip === 'both',
            'fa-flip-vertical': this.flip === 'vertical' || this.flip === 'both',

            'fa-rotate-90': this.rotate === '90',
            'fa-rotate-180': this.rotate === '180',
            'fa-rotate-270': this.rotate === '270',
        };
    }
}
